export default __webpack_public_path__ + "static/ilaeco-davao-8253639313be38f16b04a64e56f97ce0.png";